








































































import { Component, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace, State } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import {
  Extra as ExtraLayout,
  Breadcrumbs as BreadcrumbsLayout,
} from '@/components/layout';
import { TransitionFade } from '@/components/transition';
import PageError from '@/pages/404.vue';
import breadcrumbsMixin from '../mixins/breadcrumbs-mixin';
import createStoreModule from './store';
import { Context, DictionaryType } from './types';
import {
  INIT,
  PROGRAM_CARD,
  PROGRAM_TITLE,
  COMPETTENCE_CARD,
  STORE_MODULE_NAME,
  COMPETTENCE_TITLE,
  EMPLOYERS,
  EDUCATION_ORGANIZATIONS,
  ORGANIZATION_SINGLE_ITEM,
} from './consts';
import {
  AppCardsList,
  AppText,
  AppHeading,
  AppPicture,
  AppTabMenu,
  AppTypeIcon,
  AppHtmlRender,
  AppRegularLink,
  AppBlockWrapper,
  AppCardTotalLayout,
  AppCardDescriptionBlockLayout,
} from '@/uikit';
import nameFromDictionary from '@/tools/nameFromDictionary';
import multiNameFromDictionary from '@/tools/multiNameFromDictionary';
import { Sidebar, Main, MapedCompetencesType, ParsedEvents } from '@/services';
import listCardSetup from '@/tools/listCardSetup';

const Profession = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [INIT]);
const fetch = actions[INIT];

@Component({
  components: {
    AppCardsList,
    AppText,
    PageError,
    AppHeading,
    AppPicture,
    AppTabMenu,
    AppTypeIcon,
    ExtraLayout,
    AppHtmlRender,
    AppRegularLink,
    TransitionFade,
    AppBlockWrapper,
    BreadcrumbsLayout,
    AppCardTotalLayout,
    AppCardDescriptionBlockLayout,
  },

  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  metaInfo(): MetaInfo {
    const {
      profession: { name },
    } = this.$store.state.profession;

    return {
      title: name || '',
    };
  },
})
export default class ProfessionCard extends Mixins(breadcrumbsMixin) {
  @Profession.State nothingFound: boolean;
  @Profession.State programs: ParsedEvents;
  @Profession.State employers: any;
  @Profession.State educationOrganizations: any;
  @Profession.State competences: MapedCompetencesType;

  @Profession.State(({ profession }) => profession.id) id: string;
  @Profession.State(({ profession }) => profession.main) main: Main;
  @Profession.State(({ profession }) => profession.name) name: string;
  @Profession.State(({ profession }) => profession.image) image: string;
  @Profession.State(({ profession }) => profession.sidebar) sidebar: Sidebar;

  @State workTypes: DictionaryType;
  @State payLevels: DictionaryType;
  @State workPlaces: DictionaryType;
  @State workSpheres: DictionaryType;
  @State profStandarts: DictionaryType;
  @State educationLevels: DictionaryType;

  get crumbs() {
    const { name, breadcrumbs } = this;
    if (!name) return breadcrumbs;
    return breadcrumbs.concat([{ text: name }]);
  }

  get listOfCards(): Array<Object> {
    const { programs, competences, employers, educationOrganizations } = this;
    return [
      ...listCardSetup(PROGRAM_TITLE, PROGRAM_CARD, programs),
      ...listCardSetup(COMPETTENCE_TITLE, COMPETTENCE_CARD, competences),
      ...listCardSetup(EMPLOYERS, ORGANIZATION_SINGLE_ITEM, employers),
      ...listCardSetup(
        EDUCATION_ORGANIZATIONS,
        ORGANIZATION_SINGLE_ITEM,
        educationOrganizations
      ),
    ];
  }

  get workType(): string {
    const { workTypes, sidebar } = this;
    return nameFromDictionary(workTypes, sidebar && sidebar.workType);
  }

  get workSphere(): string {
    const { workSpheres, sidebar } = this;
    return nameFromDictionary(workSpheres, sidebar && sidebar.workSphere);
  }

  get payLevel(): string {
    const { payLevels, sidebar } = this;
    return nameFromDictionary(payLevels, sidebar && sidebar.payLevel);
  }

  get educationLevel(): string {
    const { educationLevels, sidebar } = this;
    return nameFromDictionary(
      educationLevels,
      sidebar && sidebar.educationRequired
    );
  }

  get professionStandarts(): string {
    const { profStandarts, sidebar } = this;
    return multiNameFromDictionary(
      profStandarts,
      sidebar && sidebar.profStandards
    );
  }

  get workPlacesNames(): string {
    const { workPlaces, sidebar } = this;
    return multiNameFromDictionary(workPlaces, sidebar && sidebar.workPlace);
  }

  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = {
      ...route.query,
      ...route.params,
    };

    return fetch.call(context, params.id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/professions/card/ProfessionCard.vue